import React, { useRef } from 'react';
import { FileDown, Printer } from 'lucide-react';
import usePdfDownload from '../../../hooks/usePdfDownload';
import { saveReportPagePdf } from './printReport';

// Print: window.print() prints the report's hidden ReportPrintLayout via the visibility trick.
// Download PDF saves that same letterhead copy; a report without one is saved as it prints.
// Neither button belongs on the paper or in the PDF.
const PrintButton = () => {
  const ref = useRef(null);
  const [downloading, download] = usePdfDownload();
  return (
    <div ref={ref} className="flex items-center gap-2 print:hidden">
      <button
        type="button"
        onClick={() => download(() => saveReportPagePdf(ref.current))}
        disabled={downloading}
        className="flex items-center gap-1.5 px-3 py-1.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 bg-white disabled:opacity-50"
        title="Save this report with the hospital letterhead as a PDF"
      >
        <FileDown className="w-4 h-4" /> {downloading ? 'Making the PDF…' : 'Download PDF'}
      </button>
      <button
        type="button"
        onClick={() => window.print()}
        className="flex items-center gap-1.5 px-3 py-1.5 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 bg-white"
        title="Print this report with the hospital letterhead"
      >
        <Printer className="w-4 h-4" /> Print
      </button>
    </div>
  );
};

export default PrintButton;
